<template lang="pug">
  form.service-form(
    @submit.prevent="() => {}"
  )
    fieldset.service-form__step(
      v-for="(step, index) in visibleSteps"
      :key="index"
      :class='index === activeStep ? "is-active" : null'
    )
      Form(
        :header="step.header"
        :description="step.description"
        :descriptionBottom="step.descriptionBottom"
        :fields="step.fields.filter(field => !field.excluded)"
        :index="step.index"
        :valid="step.valid ? true : false"
        :skip="step.skip ? step.skip : false"
      )
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import Form from "@/components/Form.vue";
import api from "@/api/reception";

export default {
  computed: {
    ...mapGetters("form", [
      "form",
      "steps",
      "activeStep",
      "plugins",
      "visibleSteps"
    ]),
    ...mapGetters("services", ["current"]),
    ...mapGetters("submit", ["submits"])
  },
  methods: {
    ...mapMutations("form", [
      "setValue",
      "setOptions",
      "setFieldRequired",
      "setFieldNotRequired"
    ]),
    ...mapMutations("submit", ["setRoute", "setSubmitData", "setSubmitAction"]),
    loadPlugins() {
      if (this.plugins) {
        this.plugins.map(async ({ type, config }) => {
          const Plugin = await import(`@/plugins/${type}`);

          if (!Array.isArray(config)) {
            config = [config];
          }

          config.forEach(configItem => {
            const pluginInstance = new Plugin.default(
              configItem,
              this.setValue.bind(this),
              this.setOptions.bind(this),
              this.setFieldNotRequired.bind(this),
              this.setFieldRequired.bind(this)
            );

            pluginInstance.init();
          });
        });
      }
    },
    formSubmit() {
      let data = {
        reception_id:
          this.submits.record && this.submits.record.data
            ? this.submits.record.data.reception_id
            : null,
        product_id: this.current,
        data: {
          ...this.form.data
        }
      };
      let errors = [];

      // const bracersFields = [
      //   "countExcerptAccountCurrentWords",
      //   "countExcerptAccountCurrentACWords",
      //   "countExcerptAccountCurrentCountACWords",
      //   "countExcerptAccountDateWords",
      //   "countExcerptOperationsPeriodWords",
      //   "countNotifyNextOperationWords",
      //   "countExcerptStocksWords",
      //   "countReferenceOtherWords"
      // ];

      // bracersFields.forEach(field => {
      //   if (data.data[field]) {
      //     data.data[field] = ` (${data.data[field]})`;
      //   }
      // });

      // const concatFields = {
      //   countExcerptAccountCurrent: "countExcerptAccountCurrentWords",
      //   countExcerptAccountCurrentAC: "countExcerptAccountCurrentACWords",
      //   countExcerptAccountCurrentCountAC:
      //     "countExcerptAccountCurrentCountACWords",
      //   countExcerptAccountDate: "countExcerptAccountDateWords",
      //   countExcerptOperationsPeriod: "countExcerptOperationsPeriodWords",
      //   countNotifyNextOperation: "countNotifyNextOperationWords",
      //   countExcerptStocks: "countExcerptStocksWords",
      //   countReferenceOther: "countReferenceOtherWords"
      // };

      // Object.keys(concatFields).forEach(field => {
      //   if (data.data[field]) {
      //     data.data[field] = `${data.data[field]} ${
      //       data.data[concatFields[field]]
      //     }`;
      //   }
      // });

      if (data.data.issuer && typeof data.data.issuer.value === "object") {
        data.data.issuer.value = data.data.issuer.value.name_full;
      }

      return api
        .order(data)
        .then(result => {
          let reception = result.data;
          this.setSubmitData(reception);
        })
        .catch(error => {
          if (error.response.data && error.response.errors) {
            for (let fieldKey in error.response.data.errors) {
              if (!error.response.data.errors.hasOwnProperty(fieldKey)) {
                continue;
              }

              error.response.data.errors[fieldKey].forEach(message => {
                errors.push(message);
              });
            }
            return errors;
          } else if (error.response.data.message) {
            return [error.response.data.message];
          }
        });
    }
  },
  components: {
    Form
  },
  mounted() {
    this.loadPlugins();
    this.setRoute(this.$route.name);
    this.setSubmitAction(this.formSubmit);
  }
};
</script>
<style lang="scss">
.service-form {
  color: $dark;

  &__step {
    display: none;
    margin: 0;
    padding: 0;
    border: none;

    &.is-active {
      display: block;
    }
  }
}
</style>
